export default __webpack_public_path__ + "static/media/sonyVegas.56f59deb.svg";